import React, {useEffect, useState} from 'react';
import GenericModal from "../../../components/modal/GenericModal";
import {ESTADO_DOCUMENTO_PAGO} from '../../../constants/hardCodedConstants';
import {  getDatosDescargaDocumentoPagoAPI, getGenerarDocumentoPagoUserAPI, getGenerarDocumentoPagoAPI} from '../../../consumers/backendApisUrls';
import { mostrarMensajeDeErrorConToast, responseCode200 } from '../../../consumers/httpRequiestsUtils';
import { useGetRequest } from '../../../hooks/useGetRequest/useGetRequest';
import './TextComponent.css';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DescargarDocumentoPago = ({toggleModal, idEmpleadoDocumentoPago, refreshTable, fromAdminPage}) => {
    const [executeGetRequest] = useGetRequest();
    const sectionName = "DescargarDocumentoPagoModal";    
    const [formConfigData, setFormConfigData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isDeclarationChecked, setIsDeclarationChecked] = useState(false);
    const [noTienePendientes, setNoTienePendientes] = useState(false);
    
    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            init();
        }

        return () => {
            unmounted = true;
        };
    }, []);

    const init = async function () {
        if (idEmpleadoDocumentoPago) {
            const response = await executeGetRequest(getDatosDescargaDocumentoPagoAPI(idEmpleadoDocumentoPago));
            if (responseCode200(response)) {
                setFormConfigData(response.data);

                if(response.data.CumplioLecturaPoliticas === false || response.data.CumplioFirmaAutorizacionDatosPersonales === false)
                    setNoTienePendientes(false)
                else
                    setNoTienePendientes(true)
                if (response.data.IdEstadoProceso === ESTADO_DOCUMENTO_PAGO.DESCARGADO) {
                    setIsDeclarationChecked(true);
                }
            } else {
                mostrarMensajeDeErrorConToast(response);
            }
        }
    }

    const generateDocumentoPago = async (event) => {
        event.preventDefault();
        console.log('Generar documento de pago para ' + idEmpleadoDocumentoPago); 
        if (formConfigData.IdEstadoProceso === ESTADO_DOCUMENTO_PAGO.REGISTRADO && !isDeclarationChecked) {
            mostrarMensajeDeErrorConToast({ data: { Message: 'Debe marcar la declaración de conocimiento antes de generar la boleta' } });
            return;
        }       
        try{    
            setIsLoading(true);
            const response = await executeGetRequest(
                fromAdminPage ? getGenerarDocumentoPagoAPI(idEmpleadoDocumentoPago)
                    :getGenerarDocumentoPagoUserAPI(idEmpleadoDocumentoPago)
                , 'blob');               
            if (responseCode200(response)) {
                toast.info("Generando y descargando archivo");
                const blob = response.data; 
                //const blob = new Blob([response.data], { type: 'application/octet-stream' });
                console.log('Blob size:', blob.size, 'Blob type:', blob.type);
                if (blob.type !== 'application/pdf') { //pdf
                    console.error('Received non-PDF content:', blob.type);
                    mostrarMensajeDeErrorConToast({ data: { Message: 'El archivo recibido no es un PDF válido' } });
                    return;
                }
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                //link.download = `boleta_${idEmpleadoDocumentoPago}.pdf`;
                link.download = `${formConfigData.NomTipoDocumento.toLowerCase()}_${formConfigData.CodigoOfisisEmpleado}_${formConfigData.AnioTipoDocumento}_${formConfigData.NumeroPeriodo}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                refreshTable();
                toggleModal();

            }else{
                console.error('Error response:', response);
                mostrarMensajeDeErrorConToast({ data: { Message: 'Error al generar el documento' } });
            }

        }catch (error) {
            console.error('Error downloading PDF:', error);
            mostrarMensajeDeErrorConToast({ data: { Message: 'Error al generar el documento: ' + error.message } });            
        }finally{
            setIsLoading(false);
        }


    }


    return (
        <GenericModal showModal={toggleModal} width={"700px"} titulo="Descargar Documento de Pago">
            <div className="modal-body">
                
                <form className="blue-standard-color">
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label modal-label">Colaborador:</label>
                        <label className="col-sm-6 col-form-label modal-label black-color-important">{formConfigData && formConfigData.NombreEmpleado}</label>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label modal-label">Sede:</label>
                        <label className="col-sm-6 col-form-label modal-label black-color-important">{formConfigData && formConfigData.NombreSede}</label>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label modal-label">Documento de pago:</label>
                        <label className="col-sm-6 col-form-label modal-label black-color-important">
                            {formConfigData.NomTipoDocumento}&nbsp;{formConfigData.AnioTipoDocumento}
                            {formConfigData.IdTipoDocumento !== 1102 && `-${formConfigData.PeriodoTipoDocumento}`}
                        </label>
                    </div>

                    {(fromAdminPage===true || noTienePendientes === true) &&
                    <div className="form-group row">
                        <div className="col-sm-12">
                            <input
                                type="checkbox"
                                checked={isDeclarationChecked}
                                onChange={(e) => setIsDeclarationChecked(e.target.checked)}
                                disabled={formConfigData.IdEstadoProceso === ESTADO_DOCUMENTO_PAGO.DESCARGADO}
                            />
                            <span className="black-color font-gothan-light">
                                {(() => {
                                    switch (formConfigData.IdTipoDocumento) {
                                        case 1100:
                                            return "Declaro haber recibido y tomado conocimiento de la entrega de mi boleta de pago de remuneraciones.";
                                        case 1101:
                                            return "Declaro haber recibido y tomado conocimiento de la entrega de mi carta de CTS.";
                                        case 1102:
                                            return `Declaro haber recibido el documento de Participación en las Utilidades correspondiente al ejercicio ${formConfigData.AnioTipoDocumento}, puesto a mi disposición a través de la Intranet.`;
                                        default:
                                            return "Declaro haber recibido y tomado conocimiento de la entrega de mi documento.";
                                    }
                                })()}
                            </span>
                            
                        </div>
                    </div>                    
                    }
                    {(fromAdminPage===true || noTienePendientes === true) &&
                    <div className="form-group row mt-4 pt-4">
                        <div className="col-sm-4 black-color button">
                            <button                             
                            className={`btn btn-primary text-nowrap generic-button-ficha ${isLoading ? "pr-2" : ""}`}
                            disabled={isLoading && (formConfigData.CumplioLecturaPoliticas === false && fromAdminPage===false)
                                || (formConfigData.IdEstadoProceso === ESTADO_DOCUMENTO_PAGO.REGISTRADO 
                                && !isDeclarationChecked)}                            
                            onClick={(event) => generateDocumentoPago(event)}>
                                Descargar {formConfigData.NomTipoDocumento} {isLoading && (<FontAwesomeIcon icon='spinner' transform="left-9" className="hand-pointer spinner ml-3"/>)}
                            </button>
                        </div>                       
                    </div>
                    }

                    {(fromAdminPage===false && noTienePendientes === false) && 
                        <div className="text-container">
                            <h2 className="text-title">
                                📌 Importante: Acceso a tus documentos de pago – Paso único
                            </h2>
                            <p className="text-description">
                                Te informamos que, por única vez, deberás completar las siguientes actividades para habilitar el acceso y descarga de tus documentos de pago (boletas electrónicas):
                            </p>
                            <ul className="text-list">
                                {formConfigData.CumplioLecturaPoliticas === false && 
                                    <li>📄 Lectura y firma del compromiso de conocimiento de políticas</li>
                                }
                                {formConfigData.CumplioFirmaAutorizacionDatosPersonales === false && 
                                <li>🔐 Validación de la autorización para el tratamiento de datos personales</li>
                                }                            
                            </ul>
                            <a href="https://intranet.innovaschools.edu.pe/misActividadesPendientes" className="text-button">
                                👉 Haz clic aquí para completar ambas actividades
                            </a>
                        </div>
                    }


                    
                    
                   
                    <div className="modal-footer mt-3">
                       &nbsp;
                    </div>

                </form>

                
            </div>                      
        </GenericModal>
    )

};
export default DescargarDocumentoPago;